/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../../theme/theme';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) System EV System Icon component -
 * always Status/Red per the Figma "EV System" Alert export (an EV System
 * alert is inherently critical), so the color is fixed rather than routed
 * through `iconColor`.
 */
export const SystemEVSystemIcon = (props: IconProps) => {
  const {iconSize} = useIconDLS(props);
  const red        = dlsColor('caRed');
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 17 15' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M13.792 5.65551C13.9814 5.28716 13.8364 4.83497 13.468 4.64553C13.0997 4.45609 12.6475 4.60113 12.458 4.96949L13.125 5.3125L13.792 5.65551Z' fill={red} />
      <path d='M10.875 9.6875L10.208 10.0305C10.3366 10.2804 10.594 10.4375 10.875 10.4375C11.156 10.4375 11.4134 10.2804 11.542 10.0305L10.875 9.6875Z' fill={red} />
      <path d='M9.29197 4.96949C9.10253 4.60113 8.65034 4.45609 8.28199 4.64553C7.91363 4.83497 7.76859 5.28716 7.95803 5.65551L8.625 5.3125L9.29197 4.96949Z' fill={red} />
      <path d='M6.75 6.0625C7.16421 6.0625 7.5 5.72671 7.5 5.3125C7.5 4.89829 7.16421 4.5625 6.75 4.5625V5.3125V6.0625Z' fill={red} />
      <path d='M3.75 5.3125V4.5625C3.33579 4.5625 3 4.89829 3 5.3125H3.75Z' fill={red} />
      <path d='M3.75 9.6875H3C3 10.1017 3.33579 10.4375 3.75 10.4375V9.6875Z' fill={red} />
      <path d='M6.75 10.4375C7.16421 10.4375 7.5 10.1017 7.5 9.6875C7.5 9.27329 7.16421 8.9375 6.75 8.9375V9.6875V10.4375Z' fill={red} />
      <path d='M3.75 6.75C3.33579 6.75 3 7.08579 3 7.5C3 7.91421 3.33579 8.25 3.75 8.25V7.5V6.75Z' fill={red} />
      <path d='M6 8.25C6.41421 8.25 6.75 7.91421 6.75 7.5C6.75 7.08579 6.41421 6.75 6 6.75V7.5V8.25Z' fill={red} />
    </svg>
  );
};

export default SystemEVSystemIcon;
